import api from "./api";
import {
  BotTokenCreate,
  BotTokenCreateResponse,
  BotTokenListResponse,
  BotTokenResponse
} from "../types/botTypes";

const bot_base = "/admin/bot-tokens";
export const botService = {
  create: async (data: BotTokenCreate): Promise<BotTokenCreateResponse> => {
    const response = await api.post(`${bot_base}/`, data);
    return response.data;
  },
  list: async (
    skip: number = 0,
    limit: number = 0,
    active_only: boolean = false,
  ): Promise<BotTokenListResponse> => {
    const response = await api.get(`${bot_base}/`);
    return response.data;
  },
  deactivate: async (id: string): Promise<BotTokenResponse> => {
    const response = await api.post(`${bot_base}/${id}/deactivate`);
    return response.data;
  },
  reactivate: async (id: string): Promise<BotTokenResponse> => {
    const response = await api.post(`${bot_base}/${id}/deactivate`);
    return response.data;
  },
};
